<template>
  <i class="fa" :class="`icmn-${name}`" aria-hidden="true"></i>
</template>

<script>
import './style.css'
export default {
  name: 'icon-icomoon',
  props: {
    name: {
      type: String,
      required: false,
      default: 'font-awesome'
    }
  }
}
</script>
